(function () {
    'use strict';

    angular
        .module('bcmModule')
        .controller('biaResponsibilityFullExecutionPlanEditController', Controller);

    Controller.$inject = ['$scope', 'bcmService', 'grcCrontabService'];

    function Controller($scope, bcmService, grcCrontabService) {

        $scope.ctrlCtxt.initBoxModel = _.cloneDeep($scope.boxModel);

        // Get Execution Plan Lookups
        bcmService
            .getBCMLookups()
            .then(function (container) {
                $scope.offsiteExecutions      = container.OffsiteExecutions;
                $scope.operationalWorkarounds = container.OperationalWorkarounds;
            });

        var hourList = [
            '00:00', '00:30', '01:00', '01:30', '02:00', '02:30', '03:00', '03:30', '04:00', '04:30', '05:00', '05:30', '06:00', '06:30', '07:00', '07:30',
            '08:00', '08:30', '09:00', '09:30', '10:00', '10:30', '11:00', '11:30', '12:00', '12:30', '13:00', '13:30', '14:00', '14:30', '15:00', '15:30',
            '16:00', '16:30', '17:00', '17:30', '18:00', '18:30', '19:00', '19:30', '20:00', '20:30', '21:00', '21:30', '22:00', '22:30', '23:00', '23:30'
        ];

        $scope.availableHourListFrom = [];
        $scope.availableHourListUntil = [];

        $scope.daysOfWeek = {
            Sunday: false,
            Monday: false,
            Tuesday: false,
            Wednesday: false,
            Thursday: false,
            Friday: false,
            Saturday: false
        };

        function initWeekDays() {
            _.each($scope.executionTimeFrame.weekDaysEN, function (day) {
                $scope.daysOfWeek[day] = true;
            });
        }

        function updateTimeframeModel() {
            if ($scope.boxModel.Is247) {
                $scope.boxModel.CronTimeframe = null;
                $scope.executionTimeFrame = null;
                delete $scope.boxModel.IsOvertime;
                delete $scope.boxModel.IsPerformedDuringPublicHolidays;
            } else {
                // From {Sunday: false, Monday: true } to ['Monday']
                $scope.executionTimeFrame.weekDaysEN = _
                    .chain($scope.daysOfWeek)
                    .keys()
                    .map(function(day) { return $scope.daysOfWeek[day] ? day : null })
                    .filter(_.isString)
                    .value();

                $scope.executionTimeFrame.weekDays =
                    grcCrontabService.getWeekDaysIndexes($scope.executionTimeFrame.weekDaysEN);

                $scope.boxModel.CronTimeframe = grcCrontabService.toCrontab($scope.executionTimeFrame);
            }
        }

        function init() {
            initWeekDays();
            $scope.updateAvailableHourListFrom();
            $scope.updateAvailableHourListUntil();
        }

        /*
            Called on init or when EndTime changes
         */
        $scope.updateAvailableHourListFrom = function() {
            if (!$scope.executionTimeFrame.endTime) {
                $scope.availableHourListFrom = hourList.slice(0, -1);
            } else {
                $scope.availableHourListFrom = hourList.slice(0, hourList.indexOf($scope.executionTimeFrame.endTime));
            }
        };

        /*
            Called on init or when StartTime changes
         */
        $scope.updateAvailableHourListUntil = function() {
            if (!$scope.executionTimeFrame.startTime) {
                $scope.availableHourListUntil = hourList.slice(1);
            } else {
                $scope.availableHourListUntil = hourList.slice(hourList.indexOf($scope.executionTimeFrame.startTime) + 1);
            }
        };

        // Get days of the week
        $scope.getDaysOfWeek = function() {
            return Object.keys($scope.daysOfWeek);
        };

        // Save Changes
        $scope.saveChanges = function () {
            updateTimeframeModel();
            $scope.onBoxModelSaveChanges($scope.form, 'Responsibility Execution updated successfully');
        };

        init();
    }
})();